/**
 * Force Logout Button
 * Red button that triggers the force logout modal
 * Only visible to caregiver_admin users
 */
const ForceLogoutButton = ({ onClick, disabled = false }) => {
  return (
    <button
      className="btn-branding"
      onClick={onClick}
      disabled={disabled}
      style={{
        color: "#fff",
        backgroundColor: "#dc3545",
        border: "2px solid #dc3545",
        opacity: disabled ? 0.6 : 1,
        cursor: disabled ? "not-allowed" : "pointer",
      }}
    >
      Force Logout from App
    </button>
  );
};

export default ForceLogoutButton;

